import React, { useEffect, useRef, useState } from 'react'
import { MdBlock, MdKeyboardArrowLeft, MdKeyboardArrowRight, MdOutlineCircle, MdOutlineDesktopMac } from 'react-icons/md';
import ReactPaginate from 'react-paginate';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import _constantUtil from '../../utils/Constant'

function AllUser() {
    const [page, setPage] = useState(_constantUtil.ONE);
    const [totalPages, setTotalPages] = useState(_constantUtil.ONE); 
    const [showConfirmation, setShowConfirmation] = useState(_constantUtil.BOOLEAN_FALSE); 
    const navigate = useNavigate()
    const confirmationRef = useRef(_constantUtil.NULL); 

    useEffect(() => { 
        const handleClickOutside = (event) => {
            if (confirmationRef.current && !confirmationRef.current.contains(event.target)) { 
            setShowConfirmation(_constantUtil.BOOLEAN_FALSE)
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };    
    }, []); 

  return (
    <>
      {showConfirmation && (
          <div>
            <div className='confirmation-overlay'></div>
            <div ref={confirmationRef} className='confirmation-dialog'>
              <p>Are you sure to update user status ?</p>
              <div className='d-flex justify-content-end '>
                <button onClick={() => setShowConfirmation(_constantUtil.BOOLEAN_FALSE)} className='border-0 rounded px-3 bg-danger text-white p-2'>Cancel</button>
                <button className='border-0 rounded px-3 bg-success text-white p-2 me-0' > Confirm  </button>
              </div>
            </div>
          </div>
        )} 
    <div className='px-4 mt-4'>  
        <div className='container-fluid p-0'>
            <div className='row'>
                <h4 className='header-title pb-3 text-muted'>All User</h4>
                <div className='col-12'>
                    <div className='card'>
                        <div className='card-body'>
                            <div className='d-flex justify-content-between align-items-center mb-2'>
                                <div className='d-flex'>
                                <select
                                    className='form-select search-width me-2'
                                    style={{ width: '60%' }} 
                                >
                                    <option value='name'>Username</option>
                                    <option value='email'>Email</option>
                                    <option value='phone'>Phone</option>
                                </select>
                                <input
                                    type='text'
                                    className='form-control  me-2'
                                    id='search'
                                    name='search'
                                    placeholder='Search...' 
                                    autoComplete='off'
                                />
                                </div> 
                            </div>
                            
                            <div className='table-responsive'>
                                <table id='scroll-horizontal-datatable' className='table w-100 nowrap'>
                                    <thead>
                                    <tr>
                                        <th>SN</th>  
                                        <th>Usename</th>
                                        <th>Email</th>
                                        <th>Phone</th>
                                        <th>Balance</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                    </thead>
                                    <tbody> 
                                        <tr >
                                            <td>1</td> 
                                            <td>test</td> 
                                            <td>testing@gmail.com</td> 
                                            <td>3213213210</td> 
                                            <td>$ 12.00</td> 
                                            <td> 
                                                <span className='badge badge-success-lighten' style={{fontSize:'13px'}}>ACTIVE</span> 
                                            </td>
                                            <td>
                                                <div className='d-flex align-items-center justify-content-center'>
                                                    <MdOutlineDesktopMac 
                                                        data-tooltip-id='viewuser' data-tooltip-content="View User"
                                                        className='jumbo-icon mdi mdi-desktop-mac me-2 fs-5 text-secondary'
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => navigate(`/user/view-user`)}
                                                    />
                                                    <Tooltip id='viewuser' place="bottom" effect="solid"/> 

                                                    <MdBlock
                                                        data-tooltip-id='inctive' data-tooltip-content="Inactive User"
                                                        className='jumbo-icon pointer user-status fs-5 me-2 text-danger' style={{cursor: 'pointer'}}   
                                                        onClick={()=>setShowConfirmation(_constantUtil.BOOLEAN_TRUE)}
                                                    />
                                                    <Tooltip id='inctive' place="bottom" effect="solid"/>
                                                </div>
                                            </td>
                                        </tr>  
                                         <tr >
                                            <td>2</td> 
                                            <td>tester</td> 
                                            <td>tester@gmail.com</td> 
                                            <td>3213234210</td> 
                                            <td>$ 1223.00</td> 
                                            <td> 
                                                <span className='badge badge-danger-lighten' style={{fontSize:'13px'}}>BANNED</span> 
                                            </td>
                                            <td>
                                                <div className='d-flex align-items-center justify-content-center'>
                                                <MdOutlineDesktopMac 
                                                    data-tooltip-id='viewuser' data-tooltip-content="View User"
                                                    className='jumbo-icon mdi mdi-desktop-mac me-2 fs-5 text-secondary'
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => navigate(`/user/view-user`)}
                                                />
                                                <Tooltip id='viewuser' place="bottom" effect="solid"/> 

                                                <MdOutlineCircle
                                                    data-tooltip-id='active' data-tooltip-content="Active User"
                                                    className='jumbo-icon pointer  text-success user-status fs-5 me-2' style={{cursor: 'pointer'}}   
                                                    onClick={()=>setShowConfirmation(_constantUtil.BOOLEAN_TRUE)}
                                                />
                                                <Tooltip id='active' place="bottom" effect="solid"/>
                                                </div>
                                            </td>
                                        </tr>
                                         <tr >
                                            <td>3</td> 
                                            <td>testtttttt</td> 
                                            <td>testingggggggg@gmail.com</td> 
                                            <td>3333333340</td> 
                                            <td>$ 1211.00</td> 
                                            <td> 
                                                <span className='badge badge-secondary-lighten' style={{fontSize:'13px'}}>UNVERIFIED</span> 
                                            </td>
                                            <td>
                                                <div className='d-flex align-items-center justify-content-center'>
                                                <MdOutlineDesktopMac 
                                                    data-tooltip-id='viewuser' data-tooltip-content="View User"
                                                    className='jumbo-icon mdi mdi-desktop-mac me-2 fs-5 text-secondary'
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => navigate(`/user/view-user`)}
                                                />
                                                <Tooltip id='viewuser' place="bottom" effect="solid"/> 
                                                </div>
                                            </td>
                                        </tr> 
                                    </tbody>
                                </table>                  
                            </div>
                            <ReactPaginate
                                className='pagination'
                                onPageChange={page => { setPage(page.selected + _constantUtil.ONE); }}
                                pageCount={totalPages}
                                previousLabel={<MdKeyboardArrowLeft className='fs-4'/>}
                                nextLabel={<MdKeyboardArrowRight className='fs-4'/>}
                                marginPagesDisplayed={2}
                                breakLabel={'...'}
                                containerClassName={'pagination-container'}
                                activeClassName={'pagination-active-page'}
                             />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </>
  )
}

export default AllUser
